exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group {\n  margin-top: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/deposits-eod-container/deposits-eod-container.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/components/deposits-eod-container/deposits-eod-container.component.scss
// module chunks = main